import { StyledRow, WrapLgMarginBottom } from "App/global-style";
import {
  NeedName,
  ProductCoverageName,
  ProductName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { Checkbox } from "Components/Form/Checkbox";
import { Select } from "Components/Form/Select";
import { AKA_GROUP_LIFE_DEATH_G_VALUE_OPTIONS } from "Features/CheckPrice/Products/Advice/adviceConstants";
import { useAkaAdviceBaseAmountSelector } from "Store/akaAdvice/akaAdviceSelectors";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { AkaGroupLifeCoverage } from "Store/interfaces/products/coverage";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { useAdviceIsLoading } from "../../../hooks/stateSelectors";
import { InsurancePrice } from "../../AdvicePrice/InsurancePrice";
import { AkaAdviceProductCoverages } from "../../AkaAdviceProductCoverage/AkaAdviceProductCoverages";
import { isBirthDateWithinRange } from "../../akaAgeUtils";
import { AkaAdvicePriceFormValues } from "../../interfaces";
import { MarginLeftWrapper } from "../../styled";
import { getAkaGroupLifeGLevelOptions } from "../../utils";

interface Props {
  formProps: FormikProps<AkaAdvicePriceFormValues>;
  recalculatePrice: (
    formValues: AkaAdvicePriceFormValues,
    specificProduct: ProductName,
  ) => void;
  priceIsChanging: boolean;
  priceIsLoading: boolean;
  coInsuredBirthDate: Date | undefined;
}

export const AkaGroupLifeDeathCoInsuredForm = ({
  formProps,
  recalculatePrice,
  priceIsChanging,
  priceIsLoading,
  coInsuredBirthDate,
}: Props): React.ReactElement | null => {
  const isLoading = useAdviceIsLoading();
  const baseAmount = useAkaAdviceBaseAmountSelector();

  if (
    !isBirthDateWithinRange(
      ProductCoverageName.AKA_GROUP_LIFE_CO_INSURED_DEATH,
      coInsuredBirthDate,
    )
  ) {
    return (
      <WrapLgMarginBottom>
        <MarginLeftWrapper>
          <p>
            Medforsikret må være mellom 18 og 70 år for å få kjøpt A+ Gruppeliv
            livsforsikring.
          </p>
        </MarginLeftWrapper>
      </WrapLgMarginBottom>
    );
  }

  return (
    <WrapLgMarginBottom>
      <StyledRow className="AkaAdviceInsuranceCoInsuredForm">
        <div>
          <Checkbox
            id="akaGroupLifeDeathCoInsuredCheckbox"
            name="akaGroupLifeDeathCoInsuredCheckbox"
            label="Medforsikret - A+ Gruppeliv livsforsikring"
          />
          {formProps.values.akaGroupLifeDeathCoInsuredCheckbox && (
            <MarginLeftWrapper>
              <Select
                large
                id="akaGroupLifeDeathCoInsuredGLevel"
                name="akaGroupLifeDeathCoInsuredGLevel"
                placeholder="Velg dekning"
                options={getAkaGroupLifeGLevelOptions(
                  "akaGroupLifeDeathGLevel",
                  AKA_GROUP_LIFE_DEATH_G_VALUE_OPTIONS,
                  baseAmount,
                )}
                disabled={isLoading}
                error={getError("akaGroupLifeDeathCoInsuredGLevel", formProps)}
                onChange={(e) =>
                  recalculatePrice(
                    {
                      ...formProps.values,
                      akaGroupLifeDeathCoInsuredGLevel: e.target.value,
                    },
                    INSURANCE_NAME_VALUE.AKA_GROUP_LIFE,
                  )
                }
              />
            </MarginLeftWrapper>
          )}
        </div>
        <InsurancePrice
          needName={NeedName.LIFE}
          productCoverages={[
            ProductCoverageName.AKA_GROUP_LIFE_CO_INSURED_DEATH,
          ]}
          priceIsChanging={priceIsChanging}
          priceIsLoading={priceIsLoading}
        />
      </StyledRow>
      <AkaAdviceProductCoverages
        backendInsuranceName={ProductBackendName.AKA_GROUP_LIFE}
        coverageGroup={AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH}
      />
    </WrapLgMarginBottom>
  );
};
